<script>
  import MiniLogo from "../Misc/MiniLogo.svelte";
  import Or from "../Misc/Or.svelte";
  import ValidationError from "../Misc/ValidationError.svelte";

  import { auth } from "../firebase";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let email = "",
    password = "";

  let emailValidationError, passwordValidationError, loginError;

  function login() {
    loginError = null;
    let formValid = loginValidation();

    if (!formValid) {
      return;
    }

    auth.signInWithEmailAndPassword(email, password).catch(function(error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode, errorMessage);
      loginError = errorMessage;
    });
  }

  function register() {
    dispatch("register");
  }

  function forgotPassword() {
    dispatch("forgotPassword");
  }

  function loginValidation() {
    let isValid = true;

    if (!email) {
      emailValidationError = "Please provide your email address";
      isValid = false;
    }

    if (!password) {
      passwordValidationError = "Please provide your password";
      isValid = false;
    }

    return isValid;
  }
</script>

<style>
  .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
  .action-button {
    padding-bottom: 10px;
  }
</style>

<form class="form-signin" on:submit|preventDefault={login}>
  <div class="text-center">
    <MiniLogo />
    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
  </div>
  <ValidationError message={loginError} />
  <div class="form-group">
    <input
      type="email"
      class="form-control"
      id="emailInput"
      aria-describedby="emailHelp"
      placeholder="Email address"
      bind:value={email}
      on:change={() => (emailValidationError = null)} />
    <ValidationError message={emailValidationError} />
    <input
      type="password"
      class="form-control"
      id="passwordInput"
      placeholder="Password"
      bind:value={password}
      on:change={() => (passwordValidationError = null)} />
    <ValidationError message={passwordValidationError} />
  </div>
  <button class="btn btn-lg btn-primary btn-block" type="submit">
    Sign in
  </button>

  <Or />
  <div class="text-center action-button">
    <button
      on:click={register}
      class="btn btn-lg btn-secondary btn-block"
      type="button">
      One-Step Registration
    </button>
  </div>
    <div class="text-center action-button">
    <button
      on:click={forgotPassword}
      class="btn btn-lg btn-light btn-block"
      type="button">
      Forgot Password
    </button>
  </div>
</form>
